import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import cc from 'classcat';
import PropTypes from 'prop-types';
import { BUTTON_TYPES } from '../../apps/homepage/constants';
import { isTargetBlank } from '../Carousel/utils';
import ButtonLink from '../ButtonLink';
import css from './HomepageFeature.module.scss';
import Image from '../Image';
import newLineToBreakTag from '../../utils/strings/newLineToBreakTag';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
var sizes = [480, 600, 900, 1200, 1600];

var Block = function Block(_ref) {
  var blockType = _ref.blockType,
      buttonType = _ref.buttonType,
      cta = _ref.cta,
      image = _ref.image,
      layout = _ref.layout,
      lazyload = _ref.lazyload,
      rawHtml = _ref.rawHtml,
      subtitle = _ref.subtitle,
      subtitleColor = _ref.subtitleColor,
      title = _ref.title,
      titleColor = _ref.titleColor,
      url = _ref.url;
  var rootClass = cc([css.root, css[blockType.toLowerCase()]]);

  if (rawHtml) {
    return /*#__PURE__*/_jsx("div", {
      className: rootClass,
      dangerouslySetInnerHTML: {
        __html: rawHtml
      }
    });
  }

  var buttonProps = _defineProperty({}, BUTTON_TYPES[buttonType], true);

  return /*#__PURE__*/_jsx("section", {
    className: rootClass,
    children: /*#__PURE__*/_jsxs("figure", {
      className: css.imageWrap,
      children: [/*#__PURE__*/_jsxs("header", {
        className: cc([css.header, css[layout.toLowerCase()]]),
        children: [title && /*#__PURE__*/_jsx("h1", {
          className: css.title,
          dangerouslySetInnerHTML: {
            __html: newLineToBreakTag(title)
          },
          style: {
            color: titleColor
          }
        }), subtitle && /*#__PURE__*/_jsx("h2", {
          className: css.subtitle,
          dangerouslySetInnerHTML: {
            __html: newLineToBreakTag(subtitle)
          },
          style: {
            color: subtitleColor
          }
        }), cta && url && /*#__PURE__*/_jsx(ButtonLink, _objectSpread(_objectSpread({
          big: true,
          className: css.cta,
          href: url,
          targetBlank: isTargetBlank(url)
        }, buttonProps), {}, {
          children: cta
        }))]
      }), image && /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, image), {}, {
        className: css.image,
        lazyload: lazyload,
        sizes: sizes
      }))]
    })
  });
};

Block.defaultProps = {
  cta: '',
  image: null,
  layout: 'LEFT',
  rawHtml: '',
  subtitle: '',
  url: ''
};
Block.propTypes = {
  blockType: PropTypes.string.isRequired,
  buttonType: PropTypes.string.isRequired,
  cta: PropTypes.string,
  image: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape()]),
  layout: PropTypes.string,
  lazyload: PropTypes.bool.isRequired,
  rawHtml: PropTypes.string,
  subtitle: PropTypes.string,
  subtitleColor: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  titleColor: PropTypes.string.isRequired,
  url: PropTypes.string
};

var HomepageFeature = function HomepageFeature(_ref2) {
  var blocks = _ref2.blocks,
      lazyload = _ref2.lazyload;
  return blocks.edges.length > 0 && blocks.edges.map(function (_ref3) {
    var node = _ref3.node;
    return /*#__PURE__*/_createElement(Block, _objectSpread(_objectSpread({}, node), {}, {
      key: node.id,
      lazyload: lazyload
    }));
  });
};

HomepageFeature.defaultProps = {
  blocks: {
    edges: []
  }
};
HomepageFeature.propTypes = {
  blocks: PropTypes.shape({
    edges: PropTypes.arrayOf(PropTypes.shape())
  }),
  lazyload: PropTypes.bool.isRequired
};
export default HomepageFeature;